
export const resellingRoutes = {
  default:'reselling',
  wordpressPlans: 'wordpressPlans'
}
